export default "__VITE_ASSET__DkmMQ6kT__"